import createReducer from './_createReducerHelper';

export const BOARDLIST = 'board/BOARDLIST';

const initialState = {
  boardList: null,
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [BOARDLIST]: (state, { payload }) => ({ ...state, boardList: payload }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param boardList
 * @return {{type, payload: *}}
 */
export const setBoardList = (boardList) => ({
  type: BOARDLIST,
  payload: boardList,
});

/** ********************************************
 * selectors
 ******************************************** */

/**
 *
 * @param state
 */
export const readStateBoardList = (state) => state.boardList.boardList;
